<template>
  <TransitionFade>
    <LoaderPanelComponent
      v-if="loadingStore.isLoading()"
      :texts="loadingStore.getLoadingTexts()"
      :overLoaderTexts="loadingStore.getOverLoaderTexts()"
      :icon="loadingStore.getIcon()"
      :loadHeader="loadingStore.loadHeader"
    />
  </TransitionFade>

  <header
    id="header"
    role="banner"
  >
    <HeaderComponent v-if="loadingStore.loadHeader" />
  </header>

  <main
    id="main-content"
    role="main"
  >
    <ToasterComponent
      :toasts="toastStore.getHeaderToasts()"
      @close="toastStore.removeToast"
      @pause="toastStore.pauseToast"
      @resume="toastStore.resumeToast"
    />

    <ModalMessageComponent
      v-if="messageStore.getModalMessage()"
      :message="messageStore.getModalMessage()"
      @clear="messageStore.clearMessage()"
    />

    <SupportChatCallComponent />

    <RouterView
      v-show="!messageStore.getModalMessage()"
      class="content"
    />
    <FooterComponent v-if="!route.meta.hideFooter" />
  </main>

  <footer
    class="main-footer"
    role="contentinfo"
  >
    <div id="footer-progress"></div>
    <div id="footer-summary"></div>
    <div id="footer-legal"></div>
  </footer>
</template>

<script setup lang="ts">
  import { useSeoMeta } from '@unhead/vue'
  import { computed, onBeforeMount, onMounted } from 'vue'
  import { RouterView, useRoute, useRouter } from 'vue-router'

  import {
    useCommonStore,
    useLoadingStore,
    useMessageStore,
    useToastStore
  } from '@/modules/core/stores'

  import {
    FooterComponent,
    HeaderComponent,
    LoaderPanelComponent,
    ModalMessageComponent,
    ToasterComponent,
    TransitionFade
  } from '@/modules/core/components'

  import SupportChatCallComponent from '@/modules/common/common/components/modals/SupportChatCallComponent.vue'

  const loadingStore = useLoadingStore()
  const messageStore = useMessageStore()
  const toastStore = useToastStore()
  const commonStore = useCommonStore()
  const route = useRoute()
  const router = useRouter()
  useSeoMeta({
    title: computed(() => (route.meta.title as string) || 'Seguros Médicos ASISA'),
    description: computed(
      () => (route.meta.description as string) || 'Asisa Web Tarificador personalizable'
    )
  })

  async function loadConfigs() {
    await router.isReady()
    await commonStore.loadBranchesConfig(route.meta.isPymes as boolean)
  }

  onBeforeMount(async () => {
    if (commonStore.getReferred() === '') commonStore.setReferred(document.referrer)
    await loadConfigs()
  })
  onMounted(() => {
    commonStore.setUrlDxp()
  })
</script>

<style lang="scss" scoped>
  header {
    width: $size-full;
    max-width: $size-1440;
    margin: 0 auto;
  }

  main {
    // max-width: 1280px; todo - move to global and use in specific pages
    position: relative;
    width: $size-full;
    margin: 0 auto;
    display: grid;
    grid-template-rows: inherit;

    .content {
      padding: 0 $spacing-l;
    }
  }

  .main-footer {
    position: sticky;
    width: $size-full;
    bottom: 0;
    z-index: $z-index-10;

    @include breakpoint-md {
      position: static;
    }

    &:has(.open) {
      position: absolute;
      top: 0;
    }
  }
</style>
